import { render, staticRenderFns } from "./VisualizarImovelMonitoramentoAgricola.vue?vue&type=template&id=224f4d34&lang=pug"
import script from "./VisualizarImovelMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./VisualizarImovelMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./VisualizarImovelMonitoramentoAgricola.vue?vue&type=style&index=0&id=224f4d34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports